<template>
  <!--  <img class alt="Vue logo" src="./assets/myimg.jpg">-->

  <div class="wrapper">
    <h1 style="margin-left: 100px">BÉO SIDA hẹ hẹ hẹ</h1>
    <img class="jumper"  ref="jumper" alt="Vue logo" src="./assets/beongu1.png">
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {},
  mounted() {
    this.intervalId = setInterval(() => {
      const x = Math.random() * 300 - 1
      const y = Math.random() * 300 - 1
      this.$refs.jumper.style.transform = `translate(${x}px, ${y}px)`
    }, 500)
  },
  beforeUnmount() {
    clearInterval(this.intervalId)
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 10px;
}

.wrapper {
  position: relative;
  width: 100vw;
  height: 50vh;
  overflow: hidden;
  background: #f0f0f0;
}

.jumper {
  position: absolute;
  width: auto;
  height: 100px;
  background-color: #ff6b6b;
  border-radius: 50%;
  transition: transform 0.4s ease;
}
</style>
